import styled from 'styled-components';

const NoTaxesMessage = styled.p`
  line-height: ${({ theme }) => theme.shopdetails.productCard.noTax.lineHeight};
  padding-top: ${({ theme }) => theme.shopdetails.productCard.noTax.paddingTop};
  display: flex;
  gap: ${({ theme }) => theme.shopdetails.productCard.noTax.gap};

  &&& {
    font-size: ${({ theme }) => theme.shopdetails.productCard.noTax.fontSize};
    color: ${({ theme }) => theme.shopdetails.productCard.noTax.color};
    font-weight: ${({ theme }) =>
      theme.shopdetails.productCard.noTax.fontWeight};
  }
`;

export default NoTaxesMessage;
